export default __webpack_public_path__ + "static/media/Jade_Round_White_Top_1.91b60ead.jpeg";